const getMethodType = (method?: string | null) => {
  if (method === 'tagName') {
    return 'タグ名';
  } else if (method === 'attrClass') {
    return 'クラス名';
  } else if (method === 'attrId') {
    return '要素ID';
  } else if (method === 'attrHref') {
    return 'href属性';
  } else if (method === 'attrSrc') {
    return 'src属性';
  } else if (method === 'attrAction') {
    return 'action属性';
  } else return '';
};

export default getMethodType;
